import React from 'react';
import { motion } from 'framer-motion';
import { Accordion } from './ui/Accordion';
export function FAQ() {
  const faqs = [{
    question: '¿Para qué año de la carrera está pensado el Mega Pack Enfermería?',
    answer: 'Está pensado principalmente para estudiantes de enfermería desde los años intermedios en adelante, especialmente quienes ya tienen o están por empezar prácticas, internado o rotaciones clínicas. Pero también sirve para estudiantes más iniciales que quieran construir una base clínica sólida desde temprano, y para enfermeros/as junior que quieran ordenar sus conocimientos.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: 'El acceso es digital e inmediato. Una vez realizada la compra, recibís los archivos en formato PDF para descargar y usar desde celular, tablet o computadora.'
  }, {
    question: '¿Qué lo diferencia de los apuntes de la facultad o del material online?',
    answer: 'Que no está pensado como teoría dispersa ni como resumen suelto. Está diseñado como un sistema clínico organizado: valoración, procedimientos, red flags, farmacología, registros, razonamiento y casos, todo conectado entre sí y orientado a la práctica real.'
  }, {
    question: '¿Tiene garantía real?',
    answer: 'Sí. Tenés una garantía de 7 días. Si lo abrís, lo revisás y sentís que no era lo que esperabas, pedís la devolución y listo.'
  }, {
    question: '¿Puedo usarlo si ya estoy trabajando como enfermero/a?',
    answer: 'Sí. De hecho, muchos profesionales jóvenes lo usan para repasar procedimientos, mejorar registros, reforzar farmacología y ordenar su razonamiento clínico.'
  }, {
    question: '¿Incluye farmacología y cálculos?',
    answer: 'Sí. El Tomo 5 está dedicado a farmacología aplicada y cálculos, y además tenés el Bono 4 como guía rápida de apoyo.'
  }, {
    question: '¿Los casos clínicos están resueltos paso a paso?',
    answer: 'Sí. El Tomo 6 incluye casos clínicos y el pack avanzado suma 30 casos adicionales resueltos con análisis, priorización, errores frecuentes y aprendizaje clave.'
  }, {
    question: '¿Está pensado para Argentina?',
    answer: 'Sí. El lenguaje, la lógica de estudio, el enfoque y la experiencia del usuario están pensados para estudiantes y profesionales de enfermería en Argentina.'
  }];
  return <section className="py-12 md:py-20 lg:py-24 bg-white" data-id="element-42">
      <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="text-center mb-8 md:mb-10" data-id="element-44">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-mid mb-4" data-id="element-45">
            Preguntas frecuentes
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black text-clinical-deep mb-3 leading-[1.05] uppercase" data-id="element-46">
            Lo que más nos{' '}
            <span className="accent-italic normal-case" data-id="element-47">preguntan</span>
          </motion.h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-3" data-id="element-48">
          {faqs.map((faq, idx) => <Accordion key={idx} title={faq.question} data-id="element-49">
              <p className="text-sm md:text-base text-clinical-ink leading-relaxed" data-id="element-50">
                {faq.answer}
              </p>
            </Accordion>)}
        </motion.div>
      </div>
    </section>;
}